import React from 'react';
import styles from './profile-button.module.scss';
import Link from 'next/link';
import { ProfileIcon } from '../icons/icons';
import colorStyle from '../../../styles/utils/variables.module.scss';
import { useTranslations } from 'next-intl';

type Props = {
  url: string;
  state: 'signIn' | 'signOut';
};

export default function ProfileButton({ url, state }: Props) {
  const translationKey = state === 'signIn' ? 'sign-in' : 'sign-out';

  const translate = useTranslations(`Common`);

  return (
    <Link href={url} className={styles['nav-button']}>
      <div className={`${styles['user-icon']} image-wrapper`}>
        <ProfileIcon fillColor={colorStyle.white} height={24} width={24} />
      </div>
      <span className='d-none d-lg-inline text-white'>{translate(`header.${translationKey}`)}</span>
    </Link>
  );
}
